import { FixedStepLoop, type FixedStepLoopOptions } from './fixed-step';

/**
 * Browser adapter of the fixed-step loop: the only place that touches requestAnimationFrame.
 * Frames use the rAF timestamp; start and resume read performance.now(), which shares its timeline.
 */
export function createAnimationFrameLoop(options: Omit<FixedStepLoopOptions, 'now'>) {
  const loop = new FixedStepLoop({ ...options, now: () => performance.now() });
  let handle = 0;

  const onFrame = (timestamp: number) => {
    loop.frame(timestamp);
    if (loop.isRunning) handle = requestAnimationFrame(onFrame);
  };

  return {
    loop,
    start() {
      if (loop.isRunning) return;
      loop.start();
      handle = requestAnimationFrame(onFrame);
    },
    stop() {
      loop.stop();
      cancelAnimationFrame(handle);
    },
  };
}
